export const BLUE = 'blue'
export const PURPLE = 'purple'
export const LIGHT_GRAY = 'light-gray'
export const DARK_GRAY = 'fav-gray'
export const GREEN = 'green'
export const RED = 'red'
export const YELLOW = 'yellow'

export const TAG_COLORS_ARRAY = [LIGHT_GRAY, BLUE, PURPLE, DARK_GRAY, GREEN, RED, YELLOW]
